webpackJsonp([7],{

/***/ 1106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationsAdd_vue__ = __webpack_require__(1254);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5169dbea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationsAdd_vue__ = __webpack_require__(1370);
function injectStyle (ssrContext) {
  __webpack_require__(1361)
  __webpack_require__(1363)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5169dbea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationsAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5169dbea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationsAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormAlert',
  props: {
    message: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'warning'
    },
    // For alerts that are created already holding their message (rendered with v-if), where the
    // `message` watcher never fires: scroll to it once when it mounts.
    scrollOnMount: {
      type: Boolean,
      default: false
    },
    // No outer padding — for alerts positioned by the caller (e.g. overlaid on a table row)
    flush: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dismissed: false
    };
  },
  mounted: function mounted() {
    if (this.scrollOnMount && this.message) this.scrollToAlert();
  },
  watch: {
    message: function message(val) {
      this.dismissed = false;
      if (val) this.scrollToAlert();
    }
  },
  methods: {
    // Click on the message closes it. Hidden locally, and `dismiss` lets a caller that keeps the
    // message in its own state clear it too (so the same text can be shown again next time).
    dismiss: function dismiss() {
      this.dismissed = true;
      this.$emit('dismiss');
    },
    scrollToAlert: function scrollToAlert() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$el) {
          _this.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__ = __webpack_require__(1126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__ = __webpack_require__(1131);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fcd5d34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("416c99d6", content, true, {});

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".form-alert[data-v-3fcd5d34]{padding:.75rem 0}.form-alert--flush[data-v-3fcd5d34]{padding:0}.form-alert__body[data-v-3fcd5d34]{cursor:pointer;white-space:pre-line;text-align:left}.fade-enter-active[data-v-3fcd5d34]{transition:opacity .3s}.fade-leave-active[data-v-3fcd5d34]{transition:opacity .15s}.fade-enter[data-v-3fcd5d34],.fade-leave-to[data-v-3fcd5d34]{opacity:0}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/FormAlert.vue"],"names":[],"mappings":"AACA,6BACE,gBAAmB,CACpB,AACD,oCACE,SAAW,CACZ,AACD,mCACE,eAAgB,AAMhB,qBAAsB,AACtB,eAAiB,CANlB,AAQD,oCACE,sBAAyB,CAC1B,AACD,oCACE,uBAA0B,CAC3B,AACD,6DAEE,SAAW,CACZ","file":"FormAlert.vue","sourcesContent":["\n.form-alert[data-v-3fcd5d34] {\n  padding: 0.75rem 0;\n}\n.form-alert--flush[data-v-3fcd5d34] {\n  padding: 0;\n}\n.form-alert__body[data-v-3fcd5d34] {\n  cursor: pointer;\n}\n\n/* Keep newlines from multi-line messages (e.g. a list of blocked competitors)\n   so they render one per line instead of a run-on sentence. */\n.form-alert__body[data-v-3fcd5d34] {\n  white-space: pre-line;\n  text-align: left;\n}\n.fade-enter-active[data-v-3fcd5d34] {\n  transition: opacity 0.3s;\n}\n.fade-leave-active[data-v-3fcd5d34] {\n  transition: opacity 0.15s;\n}\n.fade-enter[data-v-3fcd5d34],\n.fade-leave-to[data-v-3fcd5d34] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.message && !_vm.dismissed)?_c('div',{staticClass:"form-alert",class:{ 'form-alert--flush': _vm.flush },attrs:{"role":"alert"}},[_c('div',{staticClass:"form-alert__body alert-pop",class:("alert alert-" + _vm.type + " mb-0"),attrs:{"title":"Click to dismiss"},on:{"click":_vm.dismiss}},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useFormAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);

function useFormAlert() {
  var message = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var type = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('warning');
  var timer = null;

  function apply(msg, autoDismiss) {
    message.value = msg;

    if (autoDismiss) {
      timer = setTimeout(function () {
        message.value = null;
      }, 5000);
    }
  }

  function show(msg, alertType, autoDismiss) {
    clearTimeout(timer);
    type.value = alertType;

    if (message.value != null) {
      message.value = null;
      Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["f" /* nextTick */])(function () {
        return apply(msg, autoDismiss);
      });
    } else {
      apply(msg, autoDismiss);
    }
  }

  function showError(msg) {
    show(msg, 'warning', true);
  }

  function showSuccess(msg) {
    show(msg != null ? msg : 'Success', 'success', true);
  }

  function showPersistentError(msg) {
    show(msg, 'warning', false);
  }

  function clear() {
    clearTimeout(timer);
    message.value = null;
  }

  return {
    message: message,
    type: type,
    showError: showError,
    showSuccess: showSuccess,
    showPersistentError: showPersistentError,
    clear: clear
  };
}

/***/ }),

/***/ 1139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppTabSwitcher',
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    modelValue: function modelValue() {
      return this.value;
    }
  }
});

/***/ }),

/***/ 1146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FCheckbox__ = __webpack_require__(145);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'BulkEditorTool',
  components: {
    FCheckbox: __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FCheckbox__["a" /* default */]
  },
  props: {
    totalCount: {
      type: Number,
      default: 0
    },
    selectedCount: {
      type: Number,
      default: 0
    }
  },
  emits: ['toggle-all']
}));

/***/ }),

/***/ 1154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(frame) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/appearances/".concat(frame));
  },
  update: function update(frame, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put("/v2/appearances/".concat(frame), data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      silent: true
    });
  },
  reset: function reset(frame) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/appearances/".concat(frame), {
      silent: true
    });
  },
  deleteField: function deleteField(frame, key) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/appearances/".concat(frame, "/").concat(key), {
      silent: true
    });
  }
});

/***/ }),

/***/ 1156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppTabSwitcher_vue__ = __webpack_require__(1139);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6ae30f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppTabSwitcher_vue__ = __webpack_require__(1157);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppTabSwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6ae30f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppTabSwitcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-switcher"},_vm._l((_vm.items),function(item){return _c('a',{key:item.value,staticClass:"tab-switcher__tab",class:{ 'tab-switcher__tab--active': _vm.modelValue === item.value },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('input', item.value)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultForm;
/* harmony export (immutable) */ __webpack_exports__["d"] = defaultPreviews;
/* harmony export (immutable) */ __webpack_exports__["a"] = applyResponse;
/* harmony export (immutable) */ __webpack_exports__["b"] = useAppearance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_appearances__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1160);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function defaultForm(config) {
  var form = {
    schema_color: '#aa2d41',
    sponsor_link: ''
  };

  if (config.hasLogoLinks) {
    for (var i = 1; i <= config.logoCount; i += 1) {
      form["sponsor_logo_".concat(i, "_link")] = '';
    }
  }

  return form;
}
function defaultPreviews(config) {
  var previews = {};
  config.fileKeys.forEach(function (key) {
    previews[key] = null;
  });
  return previews;
}
function applyResponse(form, previews, data, config) {
  form.schema_color = data.schema_color != null ? data.schema_color : '#aa2d41';
  form.sponsor_link = data.sponsor_link != null ? data.sponsor_link : '';

  if (config.hasLogoLinks) {
    for (var i = 1; i <= config.logoCount; i += 1) {
      var linkKey = "sponsor_logo_".concat(i, "_link");
      form[linkKey] = data[linkKey] != null ? data[linkKey] : '';
    }
  }

  config.fileKeys.forEach(function (key) {
    previews[key] = data[key] != null ? data[key] : null;
  });
}
function useAppearance(frameArg) {
  var frameRef = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["e" /* isRef */])(frameArg) ? frameArg : Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(frameArg);
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* FRAME_CONFIG */][frameRef.value];
  });
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var form = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])(defaultForm(config.value));
  var previews = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])(defaultPreviews(config.value));

  function fetch() {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_appearances__["a" /* default */].get(frameRef.value);

            case 4:
              res = _context.sent;
              applyResponse(form, previews, res.data.data, config.value);

            case 6:
              _context.prev = 6;
              loading.value = false;
              return _context.finish(6);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 6, 9]]);
    }));
    return _fetch.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(frameRef, function () {
    Object.assign(form, defaultForm(config.value));
    Object.assign(previews, defaultPreviews(config.value));
    fetch();
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(fetch);
  return {
    loading: loading,
    form: form,
    previews: previews,
    config: config,
    fetch: fetch
  };
}

/***/ }),

/***/ 1160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LEADERBOARD_FILE_KEYS */
/* unused harmony export NOMINATIONS_FILE_KEYS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FRAME_CONFIG; });
var LEADERBOARD_FILE_KEYS = ['sponsor_logo_1', 'sponsor_logo_2', 'sponsor_logo_3', 'sponsor_logo_desktop', 'sponsor_logo_mobile'];
var NOMINATIONS_FILE_KEYS = ['sponsor_logo_1', 'sponsor_logo_2', 'sponsor_logo_desktop', 'sponsor_logo_mobile'];
var FRAME_CONFIG = {
  leaderboard: {
    title: 'Leaderboard Appearance',
    logoCount: 3,
    hasLogoLinks: true,
    fileKeys: LEADERBOARD_FILE_KEYS
  },
  nominations: {
    title: 'Nominations Appearance',
    logoCount: 2,
    hasLogoLinks: false,
    fileKeys: NOMINATIONS_FILE_KEYS
  }
};

/***/ }),

/***/ 1182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulkEditorTool_vue__ = __webpack_require__(1146);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1e57b00_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BulkEditorTool_vue__ = __webpack_require__(1185);
function injectStyle (ssrContext) {
  __webpack_require__(1183)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1e57b00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulkEditorTool_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1e57b00_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BulkEditorTool_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1183:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1184);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("5bbcc44f", content, true, {});

/***/ }),

/***/ 1184:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".bulk-editor-tool__title[data-v-e1e57b00]{display:block;margin-bottom:.3rem;font-weight:700;font-size:1.094rem}@media (max-width:1024px){.tools_events_bar[data-v-e1e57b00]{flex-direction:column!important;align-items:flex-start!important;justify-content:flex-start!important}.tools_events_bar>[data-v-e1e57b00]{margin-bottom:.75rem}.tools_events_bar>[data-v-e1e57b00]:first-child{margin-bottom:.75rem!important}.tools_events_bar>[data-v-e1e57b00]:last-child{margin-bottom:0}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/BulkEditorTool.vue"],"names":[],"mappings":"AACA,0CACE,cAAe,AACf,oBAAsB,AACtB,gBAAiB,AACjB,kBAAoB,CACrB,AACD,0BACA,mCACI,gCAAkC,AAClC,iCAAmC,AACnC,oCAAuC,CAC1C,AACD,oCACI,oBAAuB,CAC1B,AACD,gDACI,8BAAkC,CACrC,AACD,+CACI,eAAiB,CACpB,CACA","file":"BulkEditorTool.vue","sourcesContent":["\n.bulk-editor-tool__title[data-v-e1e57b00] {\n  display: block;\n  margin-bottom: 0.3rem;\n  font-weight: 700;\n  font-size: 1.094rem;\n}\n@media (max-width: 1024px) {\n.tools_events_bar[data-v-e1e57b00] {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    justify-content: flex-start !important;\n}\n.tools_events_bar > *[data-v-e1e57b00] {\n    margin-bottom: 0.75rem;\n}\n.tools_events_bar > *[data-v-e1e57b00]:first-child {\n    margin-bottom: 0.75rem !important;\n}\n.tools_events_bar > *[data-v-e1e57b00]:last-child {\n    margin-bottom: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"bulk-editor-tool__title"},[_vm._v("Bulk Editor Tool")]),_vm._v(" "),_c('div',{staticClass:"tools_events_bar mb-3 p-2 p-sm-3 bg-lighter border-top d-flex align-items-center flex-wrap justify-content-around"},[_c('f-checkbox',{staticClass:"mb-0 mr-3 flex-shrink-0",attrs:{"id":"bulk-select-all","label":"Select all","value":_vm.totalCount > 0 && _vm.selectedCount === _vm.totalCount,"font-normal":true},on:{"input":function($event){return _vm.$emit('toggle-all')}}}),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getForm: function getForm(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/biosecurity"));
  },
  createForm: function createForm(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/biosecurity"), data, {
      silent: true
    });
  },
  updateForm: function updateForm(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/biosecurity"), data, {
      silent: true
    });
  },
  getBlankPdf: function getBlankPdf() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/nominations/biosecurity-blank-form', {
      responseType: 'blob'
    });
  },
  downloadReport: function downloadReport(draftId, format) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/biosecurity/report"), {
      params: {
        format: format
      },
      responseType: 'blob'
    });
  }
});

/***/ }),

/***/ 1254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppTabSwitcher__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FormFields_FCheckbox__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FormFields_FText__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FormAlert__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AppTooltip__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Leaders_Listing_components_AppearancesDraftsHeader__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Leaders_Listing_components_AppearancesDraftsDesktopBanner__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__composables_appearances_useAppearance__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__composables_nominations_useNominationAdd__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_date__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_api_biosecurity__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_NominationsAddList__ = __webpack_require__(1366);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'NominationsAdd',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_3__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_4__components_PageHeading__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_5__components_AppButton__["a" /* default */],
    AppTabSwitcher: __WEBPACK_IMPORTED_MODULE_6__components_AppTabSwitcher__["a" /* default */],
    FCheckbox: __WEBPACK_IMPORTED_MODULE_7__components_FormFields_FCheckbox__["a" /* default */],
    FText: __WEBPACK_IMPORTED_MODULE_8__components_FormFields_FText__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_9__components_FormAlert__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_1__components_AppMultiselect__["a" /* default */],
    Draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a,
    AppTooltip: __WEBPACK_IMPORTED_MODULE_10__components_AppTooltip__["a" /* default */],
    AppearancesDraftsHeader: __WEBPACK_IMPORTED_MODULE_11__views_Leaders_Listing_components_AppearancesDraftsHeader__["a" /* default */],
    AppearancesDraftsDesktopBanner: __WEBPACK_IMPORTED_MODULE_12__views_Leaders_Listing_components_AppearancesDraftsDesktopBanner__["a" /* default */],
    NominationsAddList: __WEBPACK_IMPORTED_MODULE_17__components_NominationsAddList__["a" /* default */]
  },
  props: {
    draftId: {
      type: [String, Number],
      required: true
    }
  },
  setup: function setup(props) {
    var _useAppearance = Object(__WEBPACK_IMPORTED_MODULE_13__composables_appearances_useAppearance__["b" /* default */])('nominations'),
        form = _useAppearance.form,
        previews = _useAppearance.previews;

    var _useNominationAdd = Object(__WEBPACK_IMPORTED_MODULE_14__composables_nominations_useNominationAdd__["a" /* default */])(props.draftId),
        draft = _useNominationAdd.draft,
        loading = _useNominationAdd.loading,
        loadFailed = _useNominationAdd.loadFailed,
        draftEvents = _useNominationAdd.draftEvents,
        memberSearchResults = _useNominationAdd.memberSearchResults,
        loadingMembers = _useNominationAdd.loadingMembers,
        selectedMember = _useNominationAdd.selectedMember,
        byEvent = _useNominationAdd.byEvent,
        byHorse = _useNominationAdd.byHorse,
        bySubmission = _useNominationAdd.bySubmission,
        submitting = _useNominationAdd.submitting,
        alert = _useNominationAdd.alert,
        userNominations = _useNominationAdd.userNominations,
        loadingNominations = _useNominationAdd.loadingNominations,
        needsToBeProcessed = _useNominationAdd.needsToBeProcessed,
        init = _useNominationAdd.init,
        searchMembers = _useNominationAdd.searchMembers,
        setMember = _useNominationAdd.setMember,
        setByEventEvent = _useNominationAdd.setByEventEvent,
        toggleHorse = _useNominationAdd.toggleHorse,
        setByHorseHorse = _useNominationAdd.setByHorseHorse,
        setBySubmissionEvent = _useNominationAdd.setBySubmissionEvent,
        submit = _useNominationAdd.submit,
        loadUserNominations = _useNominationAdd.loadUserNominations;

    var activeTab = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('event');
    var hasNoHorseEvents = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return bySubmission.events.length > 0;
    });
    var tabItems = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var items = [{
        value: 'event',
        label: 'Nominate by event'
      }, {
        value: 'horse',
        label: 'Nominate by horse'
      }];

      if (hasNoHorseEvents.value) {
        items.push({
          value: 'submission',
          label: 'Nominate without a horse'
        });
      }

      return items;
    });
    var submissionMaxQuantity = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (bySubmission.maxSubmissions == null) return null;
      var remaining = bySubmission.maxSubmissions - (bySubmission.used || 0);
      return remaining > 0 ? remaining : 0;
    });
    var appearances = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return _objectSpread({}, previews, {}, form);
    });
    var bannerHidden = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function onScroll() {
      if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 10) {
        bannerHidden.value = true;
      }
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      return window.addEventListener('scroll', onScroll);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["j" /* onUnmounted */])(function () {
      return window.removeEventListener('scroll', onScroll);
    });
    var colorRgb = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var hex = (appearances.value.schema_color || '#aa2d41').replace('#', '');
      var r = parseInt(hex.substring(0, 2), 16);
      var g = parseInt(hex.substring(2, 4), 16);
      var b = parseInt(hex.substring(4, 6), 16);
      return "".concat(r, ", ").concat(g, ", ").concat(b);
    });
    var canSubmit = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (selectedMember.value == null) return false;

      if (activeTab.value === 'event') {
        return byEvent.eventId != null && byEvent.selectedHorseIds.length > 0;
      }

      if (activeTab.value === 'submission') {
        if (bySubmission.eventId == null || bySubmission.quantity == null) return false;
        if (bySubmission.quantity < 1) return false;
        if (submissionMaxQuantity.value != null && bySubmission.quantity > submissionMaxQuantity.value) return false;
        return true;
      }

      if (byHorse.horseId == null || byHorse.selectedEventId == null) return false;
      var selectedEv = byHorse.events.find(function (e) {
        return e.id === byHorse.selectedEventId;
      });
      return selectedEv == null || !selectedEv.nominated && !selectedEv.nominated_in_combined;
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(init);

    function onMemberOpen() {
      if (memberSearchResults.value.length === 0) {
        searchMembers('');
      }
    }

    var orderedSelectedHorses = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);

    function onHorseToggle(horseId) {
      var found = byEvent.horses.find(function (h) {
        return h.id === horseId;
      });
      if (found != null && found.disabled) return;
      toggleHorse(horseId);
      var isNowSelected = byEvent.selectedHorseIds.indexOf(horseId) !== -1;

      if (isNowSelected) {
        var horse = byEvent.horses.find(function (h) {
          return h.id === horseId;
        });
        if (horse) orderedSelectedHorses.value.push(horse);
      } else {
        var idx = orderedSelectedHorses.value.findIndex(function (h) {
          return h.id === horseId;
        });
        if (idx !== -1) orderedSelectedHorses.value.splice(idx, 1);
      }
    }

    function onPreviewDragEnd() {
      var _byEvent$selectedHors;

      var newOrder = orderedSelectedHorses.value.map(function (h) {
        return h.id;
      });

      (_byEvent$selectedHors = byEvent.selectedHorseIds).splice.apply(_byEvent$selectedHors, [0, byEvent.selectedHorseIds.length].concat(_toConsumableArray(newOrder)));
    }

    function eventNomTooltip(ev) {
      if (ev.nominated) return 'Already nominated';
      if (ev.nominated_in_combined) return 'Already nominated in combined event';
      return '';
    }

    function onMemberInput(member) {
      setMember(member);
      orderedSelectedHorses.value = [];
    } // Secretary/admin hint: why an otherwise-unfinancial member is nominatable (CAM-1485)


    function memberVolunteerNote(member) {
      if (member == null) return '';
      if (member.is_volunteer) return 'Volunteer';
      if (member.is_volunteer_family) return 'Volunteer family';
      return '';
    }

    function onByEventEventInput(ev) {
      setByEventEvent(ev != null ? ev.id : null);
      orderedSelectedHorses.value = [];
    }

    function onByHorseHorseInput(horse) {
      setByHorseHorse(horse != null ? horse.id : null);
    }

    function onBySubmissionEventInput(ev) {
      setBySubmissionEvent(ev != null ? ev.id : null);
    }

    function reloadHorseList() {
      if (activeTab.value === 'event' && byEvent.eventId != null && selectedMember.value != null) {
        setByEventEvent(byEvent.eventId);
      } else if (activeTab.value === 'horse' && byHorse.horseId != null && selectedMember.value != null) {
        setByHorseHorse(byHorse.horseId);
      }
    }

    function handleSubmit() {
      return _handleSubmit.apply(this, arguments);
    }

    function _handleSubmit() {
      _handleSubmit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var ok;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return submit(activeTab.value);

              case 2:
                ok = _context.sent;

                if (ok) {
                  orderedSelectedHorses.value = [];
                  reloadHorseList();
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _handleSubmit.apply(this, arguments);
    }

    function onListReload() {
      return _onListReload.apply(this, arguments);
    }

    function _onListReload() {
      _onListReload = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var userId;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                userId = selectedMember.value != null ? selectedMember.value.id : null;
                _context2.next = 3;
                return loadUserNominations(userId, true);

              case 3:
                reloadHorseList();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _onListReload.apply(this, arguments);
    }

    var downloadingBlankFormFlag = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function downloadBlankForm() {
      return _downloadBlankForm.apply(this, arguments);
    }

    function _downloadBlankForm() {
      _downloadBlankForm = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var res, blobUrl;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                downloadingBlankFormFlag.value = true;
                _context3.prev = 1;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_16__services_api_biosecurity__["a" /* default */].getBlankPdf();

              case 4:
                res = _context3.sent;
                blobUrl = URL.createObjectURL(new Blob([res.data], {
                  type: 'application/pdf'
                }));
                window.open(blobUrl, '_blank');
                _context3.next = 11;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);

              case 11:
                _context3.prev = 11;
                downloadingBlankFormFlag.value = false;
                return _context3.finish(11);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 9, 11, 14]]);
      }));
      return _downloadBlankForm.apply(this, arguments);
    }

    return {
      draft: draft,
      loading: loading,
      loadFailed: loadFailed,
      draftEvents: draftEvents,
      memberSearchResults: memberSearchResults,
      loadingMembers: loadingMembers,
      selectedMember: selectedMember,
      byEvent: byEvent,
      byHorse: byHorse,
      bySubmission: bySubmission,
      submissionMaxQuantity: submissionMaxQuantity,
      submitting: submitting,
      alert: alert,
      userNominations: userNominations,
      loadingNominations: loadingNominations,
      needsToBeProcessed: needsToBeProcessed,
      activeTab: activeTab,
      tabItems: tabItems,
      hasNoHorseEvents: hasNoHorseEvents,
      appearances: appearances,
      bannerHidden: bannerHidden,
      colorRgb: colorRgb,
      canSubmit: canSubmit,
      orderedSelectedHorses: orderedSelectedHorses,
      searchMembers: searchMembers,
      setMember: setMember,
      toggleHorse: toggleHorse,
      eventNomTooltip: eventNomTooltip,
      onHorseToggle: onHorseToggle,
      memberVolunteerNote: memberVolunteerNote,
      onBySubmissionEventInput: onBySubmissionEventInput,
      onPreviewDragEnd: onPreviewDragEnd,
      onMemberInput: onMemberInput,
      onMemberOpen: onMemberOpen,
      onByEventEventInput: onByEventEventInput,
      onByHorseHorseInput: onByHorseHorseInput,
      handleSubmit: handleSubmit,
      onListReload: onListReload,
      formatDate: __WEBPACK_IMPORTED_MODULE_15__utils_date__["a" /* formatDate */],
      downloadingBlankForm: downloadingBlankFormFlag,
      downloadBlankForm: downloadBlankForm
    };
  }
}));

/***/ }),

/***/ 1255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FCheckbox__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormAlert__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ConfirmModal__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_BulkEditorTool__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__composables_useFormAlert__ = __webpack_require__(1132);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'NominationsAddList',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_1__components_AppMultiselect__["a" /* default */],
    Draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a,
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */],
    FCheckbox: __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FCheckbox__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_5__components_FormAlert__["a" /* default */],
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_6__components_ConfirmModal__["a" /* default */],
    BulkEditorTool: __WEBPACK_IMPORTED_MODULE_7__components_BulkEditorTool__["a" /* default */]
  },
  props: {
    userNominations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loadingNominations: {
      type: Boolean,
      default: false
    },
    // Admin browsing another member's nominations (see NominationsAdd.vue) — lets the
    // competitor picker show that member's family instead of the admin's own. Ignored by
    // the backend for anyone who isn't an Admin.
    targetUserId: {
      type: Number,
      default: null
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var groupAlerts = {};

    function getGroupAlert(eventId) {
      if (groupAlerts[eventId] == null) {
        groupAlerts[eventId] = Object(__WEBPACK_IMPORTED_MODULE_9__composables_useFormAlert__["a" /* default */])();
      }

      return groupAlerts[eventId];
    }

    var scratchAlert = Object(__WEBPACK_IMPORTED_MODULE_9__composables_useFormAlert__["a" /* default */])();
    var scratchSelectedIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    var scratchConfirmPending = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var deleteConfirmPending = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var membersByNom = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});
    var horsesByNom = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});
    var horseOverrides = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});
    var riderOverrides = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});
    var quantityOverrides = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});

    function loadMembersForNom(_x, _x2) {
      return _loadMembersForNom.apply(this, arguments);
    }

    function _loadMembersForNom() {
      _loadMembersForNom = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(nomId, horseId) {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(membersByNom.value[nomId] != null)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                membersByNom.value = _objectSpread({}, membersByNom.value, _defineProperty({}, nomId, []));
                _context.prev = 3;
                params = {
                  horse_id: horseId
                };
                if (props.targetUserId != null) params.user_id = props.targetUserId;
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__["a" /* default */].members(params);

              case 8:
                res = _context.sent;
                membersByNom.value = _objectSpread({}, membersByNom.value, _defineProperty({}, nomId, res.data.data));
                _context.next = 14;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](3);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 12]]);
      }));
      return _loadMembersForNom.apply(this, arguments);
    }

    function loadHorsesForNom(_x3, _x4, _x5) {
      return _loadHorsesForNom.apply(this, arguments);
    }

    function _loadHorsesForNom() {
      _loadHorsesForNom = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(nomId, riderId, eventId) {
        var res, horses;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(horsesByNom.value[nomId] != null)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                horsesByNom.value = _objectSpread({}, horsesByNom.value, _defineProperty({}, nomId, []));
                _context2.prev = 3;
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__["a" /* default */].memberHorses(riderId, {
                  event_id: eventId
                });

              case 6:
                res = _context2.sent;
                horses = res.data.data.horses != null ? res.data.data.horses : [];
                horsesByNom.value = _objectSpread({}, horsesByNom.value, _defineProperty({}, nomId, horses));
                _context2.next = 13;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](3);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 11]]);
      }));
      return _loadHorsesForNom.apply(this, arguments);
    }

    var groupedNominations = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var groups = {};
      props.userNominations.forEach(function (nom) {
        var key = nom.event.id;

        if (groups[key] == null) {
          groups[key] = {
            event: nom.event,
            nominations: []
          };
        }

        groups[key].nominations.push(nom);
      });
      return Object.values(groups).sort(function (a, b) {
        return b.event.id - a.event.id;
      }).map(function (group, groupIndex) {
        var memberMap = {};
        group.nominations.forEach(function (nom) {
          var key = nom.rider.id;

          if (memberMap[key] == null) {
            memberMap[key] = {
              rider: nom.rider,
              nominations: []
            };
          }

          memberMap[key].nominations.push(nom);
        });
        var memberGroups = Object.values(memberMap).map(function (mg, i) {
          return _objectSpread({}, mg, {
            colorIndex: (groupIndex + i) % 2
          });
        });
        var totalPrice = group.nominations.reduce(function (sum, nom) {
          return sum + parseFloat(nom.effective_cost);
        }, 0);
        var isNoHorse = group.nominations.length > 0 && group.nominations[0].horse.id == null;
        return _objectSpread({}, group, {
          memberGroups: memberGroups,
          totalPrice: totalPrice,
          isNoHorse: isNoHorse
        });
      });
    }); // Per-member remaining Quantity quota for a no-horse event, keyed by nomination id — mirrors
    // the backend's per-person max_submissions check (this member's other quantities in the same
    // event, capped at event.max_submissions). Kept separate from groupedNominations so the
    // draggable member-group arrays stay untouched (vuedraggable mutates them in place on reorder).

    var quantityMaxByNomId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var result = {};
      groupedNominations.value.forEach(function (group) {
        if (group.event.max_submissions == null) return;
        group.memberGroups.forEach(function (mg) {
          var memberTotal = mg.nominations.reduce(function (sum, n) {
            return sum + (n.quantity || 0);
          }, 0);
          mg.nominations.forEach(function (n) {
            result[n.id] = group.event.max_submissions - (memberTotal - (n.quantity || 0));
          });
        });
      });
      return result;
    });
    var allNomIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.userNominations.map(function (n) {
        return n.id;
      });
    });
    var combinedGroupNumbers = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var map = {};
      var seen = {};
      var counter = 0;
      props.userNominations.forEach(function (nom) {
        if (nom.comb_nomination_id == null) return;
        var pairKey = [nom.id, nom.comb_nomination_id].sort().join('-');

        if (seen[pairKey] == null) {
          counter += 1;
          seen[pairKey] = counter;
        }

        map[nom.id] = seen[pairKey];
      });
      return map;
    });

    function extractApiError(err) {
      var data = err.response != null ? err.response.data : null;
      return data != null && data.message != null ? data.message : 'A server error occurred';
    }

    function toggleScratchSelect(nomId) {
      var idx = scratchSelectedIds.value.indexOf(nomId);

      if (idx === -1) {
        scratchSelectedIds.value = [].concat(_toConsumableArray(scratchSelectedIds.value), [nomId]);
      } else {
        scratchSelectedIds.value = scratchSelectedIds.value.filter(function (id) {
          return id !== nomId;
        });
      }
    }

    function toggleSelectAll() {
      if (scratchSelectedIds.value.length === allNomIds.value.length) {
        scratchSelectedIds.value = [];
      } else {
        scratchSelectedIds.value = _toConsumableArray(allNomIds.value);
      }
    }

    function handleDelete() {
      return _handleDelete.apply(this, arguments);
    }

    function _handleDelete() {
      _handleDelete = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var _deleteConfirmPending, nomId, eventId, res, msg;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(deleteConfirmPending.value == null)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _deleteConfirmPending = deleteConfirmPending.value, nomId = _deleteConfirmPending.nomId, eventId = _deleteConfirmPending.eventId;
                deleteConfirmPending.value = null;
                _context3.prev = 4;
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__["a" /* default */].deleteNomination(nomId);

              case 7:
                res = _context3.sent;
                msg = res != null && res.data != null ? res.data.message : null;
                if (msg) getGroupAlert(eventId).showSuccess(msg);
                emit('reload');
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](4);
                getGroupAlert(eventId).showError(extractApiError(_context3.t0));

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[4, 13]]);
      }));
      return _handleDelete.apply(this, arguments);
    }

    function handleBulkScratch() {
      return _handleBulkScratch.apply(this, arguments);
    }

    function _handleBulkScratch() {
      _handleBulkScratch = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var res, msg;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                scratchConfirmPending.value = false;

                if (!(scratchSelectedIds.value.length === 0)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                _context4.prev = 3;
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__["a" /* default */].bulkScratch({
                  nomination_ids: scratchSelectedIds.value
                });

              case 6:
                res = _context4.sent;
                scratchSelectedIds.value = [];
                msg = res != null && res.data != null ? res.data.message : null;
                if (msg) scratchAlert.showSuccess(msg);
                emit('reload');
                _context4.next = 16;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](3);
                scratchAlert.showError(extractApiError(_context4.t0));

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[3, 13]]);
      }));
      return _handleBulkScratch.apply(this, arguments);
    }

    function handleRiderChange(_x6, _x7, _x8) {
      return _handleRiderChange.apply(this, arguments);
    }

    function _handleRiderChange() {
      _handleRiderChange = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5(nomId, memberId, eventId) {
        var res, newCache, msg, reverted;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__["a" /* default */].updateNomination(nomId, {
                  user_member_id: memberId
                });

              case 3:
                res = _context5.sent;
                newCache = _objectSpread({}, horsesByNom.value);
                delete newCache[nomId];
                horsesByNom.value = newCache;
                msg = res != null && res.data != null ? res.data.message : null;
                if (msg) getGroupAlert(eventId).showSuccess(msg);
                emit('reload');
                _context5.next = 18;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](0);
                reverted = _objectSpread({}, riderOverrides.value);
                delete reverted[nomId];
                riderOverrides.value = reverted;
                getGroupAlert(eventId).showError(extractApiError(_context5.t0));

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 12]]);
      }));
      return _handleRiderChange.apply(this, arguments);
    }

    function handleHorseChange(_x9, _x10, _x11) {
      return _handleHorseChange.apply(this, arguments);
    }

    function _handleHorseChange() {
      _handleHorseChange = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6(nomId, horseId, eventId) {
        var res, newMemberCache, msg, reverted;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__["a" /* default */].updateNomination(nomId, {
                  horse_id: Number(horseId)
                });

              case 3:
                res = _context6.sent;
                newMemberCache = _objectSpread({}, membersByNom.value);
                delete newMemberCache[nomId];
                membersByNom.value = newMemberCache;
                msg = res != null && res.data != null ? res.data.message : null;
                if (msg) getGroupAlert(eventId).showSuccess(msg);
                emit('reload');
                _context6.next = 18;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](0);
                reverted = _objectSpread({}, horseOverrides.value);
                delete reverted[nomId];
                horseOverrides.value = reverted;
                getGroupAlert(eventId).showError(extractApiError(_context6.t0));

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 12]]);
      }));
      return _handleHorseChange.apply(this, arguments);
    }

    var quantityUpdatingIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);

    function handleQuantityChange(_x12, _x13, _x14) {
      return _handleQuantityChange.apply(this, arguments);
    }

    function _handleQuantityChange() {
      _handleQuantityChange = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee7(nomId, quantity, eventId) {
        var res, msg, reverted;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                quantityUpdatingIds.value = quantityUpdatingIds.value.concat(nomId);
                _context7.prev = 1;
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__["a" /* default */].updateNomination(nomId, {
                  quantity: quantity
                });

              case 4:
                res = _context7.sent;
                msg = res != null && res.data != null ? res.data.message : null;
                if (msg) getGroupAlert(eventId).showSuccess(msg);
                emit('reload');
                _context7.next = 16;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](1);
                reverted = _objectSpread({}, quantityOverrides.value);
                delete reverted[nomId];
                quantityOverrides.value = reverted;
                getGroupAlert(eventId).showError(extractApiError(_context7.t0));

              case 16:
                _context7.prev = 16;
                quantityUpdatingIds.value = quantityUpdatingIds.value.filter(function (id) {
                  return id !== nomId;
                });
                return _context7.finish(16);

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[1, 10, 16, 19]]);
      }));
      return _handleQuantityChange.apply(this, arguments);
    }

    function onQuantityChange(nomId, value, eventId) {
      var quantity = Number(value);
      if (!Number.isInteger(quantity) || quantity < 1) return;
      var max = quantityMaxByNomId.value[nomId];
      if (max != null && quantity > max) quantity = max;
      quantityOverrides.value = _objectSpread({}, quantityOverrides.value, _defineProperty({}, nomId, quantity));
      handleQuantityChange(nomId, quantity, eventId);
    }

    function horseOptionsForNom(nomId, currentHorseId) {
      var horses = horsesByNom.value[nomId];
      if (horses == null) return [];
      return horses.filter(function (h) {
        return h.id !== currentHorseId;
      }).map(function (h) {
        return h.disabled ? _objectSpread({}, h, {
          $isDisabled: true
        }) : h;
      });
    }

    function onHorseSelect(nomId, horse, eventId) {
      if (horse == null || horse.disabled) return;
      horseOverrides.value = _objectSpread({}, horseOverrides.value, _defineProperty({}, nomId, horse));
      handleHorseChange(nomId, horse.id, eventId);
    }

    function riderForNom(nom) {
      var members = membersByNom.value[nom.id];

      if (members != null) {
        var found = members.find(function (m) {
          return m.id === nom.rider.id;
        });
        if (found) return found;
      }

      return {
        id: nom.rider.id,
        full_name: "".concat(nom.rider.first_name, " ").concat(nom.rider.last_name)
      };
    }

    function onRiderSelect(nomId, member, eventId) {
      if (member == null) return;
      riderOverrides.value = _objectSpread({}, riderOverrides.value, _defineProperty({}, nomId, member));
      handleRiderChange(nomId, member.id, eventId);
    }

    function onDragEnd(_x15, _x16) {
      return _onDragEnd.apply(this, arguments);
    }

    function _onDragEnd() {
      _onDragEnd = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee8(nominations, eventId) {
        var items, res, msg;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                items = nominations.map(function (nom, index) {
                  return {
                    id: nom.id,
                    order: index + 1
                  };
                });
                _context8.prev = 1;
                _context8.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__["a" /* default */].reorderNominations({
                  items: items
                });

              case 4:
                res = _context8.sent;
                msg = res != null && res.data != null ? res.data.message : null;
                if (msg) getGroupAlert(eventId).showSuccess(msg);
                emit('reload');
                _context8.next = 13;
                break;

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8["catch"](1);
                getGroupAlert(eventId).showError(extractApiError(_context8.t0));

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[1, 10]]);
      }));
      return _onDragEnd.apply(this, arguments);
    }

    return {
      scratchAlert: scratchAlert,
      scratchSelectedIds: scratchSelectedIds,
      scratchConfirmPending: scratchConfirmPending,
      deleteConfirmPending: deleteConfirmPending,
      membersByNom: membersByNom,
      loadMembersForNom: loadMembersForNom,
      horsesByNom: horsesByNom,
      loadHorsesForNom: loadHorsesForNom,
      groupedNominations: groupedNominations,
      allNomIds: allNomIds,
      combinedGroupNumbers: combinedGroupNumbers,
      getGroupAlert: getGroupAlert,
      toggleScratchSelect: toggleScratchSelect,
      toggleSelectAll: toggleSelectAll,
      handleDelete: handleDelete,
      handleBulkScratch: handleBulkScratch,
      handleRiderChange: handleRiderChange,
      handleHorseChange: handleHorseChange,
      onDragEnd: onDragEnd,
      horseOverrides: horseOverrides,
      riderOverrides: riderOverrides,
      quantityOverrides: quantityOverrides,
      quantityMaxByNomId: quantityMaxByNomId,
      quantityUpdatingIds: quantityUpdatingIds,
      horseOptionsForNom: horseOptionsForNom,
      onHorseSelect: onHorseSelect,
      riderForNom: riderForNom,
      onRiderSelect: onRiderSelect,
      onQuantityChange: onQuantityChange
    };
  }
}));

/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1362);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("7dfea5ec", content, true, {});

/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".nom-add__layout[data-v-5169dbea]{display:grid;grid-template-columns:3fr 1fr;grid-gap:16px;padding:0 16px 16px;font-size:1.1rem}.biosecurity-actions__download[data-v-5169dbea]{margin-left:1rem;justify-content:center}.nom-add__actions[data-v-5169dbea]{row-gap:12px}@media (max-width:450px){.biosecurity-actions[data-v-5169dbea]{flex-direction:column;align-items:stretch}.biosecurity-actions>[data-v-5169dbea]{margin-top:12px}.biosecurity-actions__download[data-v-5169dbea]{margin-left:0}}.nominations__item[data-v-5169dbea]{margin-top:12px;margin-bottom:12px}.nom-add__select[data-v-5169dbea]{max-width:320px}.nom-add__label[data-v-5169dbea]{min-width:200px;flex-shrink:0}@media (max-width:768px){.nom-add__layout[data-v-5169dbea]{grid-template-columns:1fr}}@media (max-width:576px){.nom-add__field[data-v-5169dbea]{flex-direction:column;align-items:stretch!important}.nom-add__label[data-v-5169dbea]{min-width:0;margin-bottom:6px}.nom-add__select[data-v-5169dbea]{max-width:none}}.horse-order-preview[data-v-5169dbea]{max-width:293px;border:1px solid var(--success-color);background-color:var(--success-bg);padding:6px 5px 0}.horse-order-preview__item[data-v-5169dbea]{text-align:center;color:var(--dark);font:700 15px Arial,sans-serif;padding:10px;margin-bottom:5px;transition:all .3s ease;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.horse-order-preview__item[data-v-5169dbea]:hover{background:var(--gray-100)}.horse-order-preview__item[data-v-5169dbea]:active{cursor:move}.horse-order-preview__num[data-v-5169dbea]{margin-right:4px}.banner-fade-enter-active[data-v-5169dbea],.banner-fade-leave-active[data-v-5169dbea]{transition:opacity 1s}.banner-fade-enter[data-v-5169dbea],.banner-fade-leave-to[data-v-5169dbea]{opacity:0}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Nominations/NominationsAdd.vue"],"names":[],"mappings":"AACA,kCACE,aAAc,AACd,8BAA+B,AAC/B,cAAe,AACf,oBAAqB,AACrB,gBAAkB,CACnB,AACD,gDACE,iBAAkB,AAClB,sBAAwB,CACzB,AACD,mCACE,YAAc,CACf,AACD,yBACA,sCACI,sBAAuB,AACvB,mBAAqB,CACxB,AACD,uCACI,eAAiB,CACpB,AACD,gDACI,aAAe,CAClB,CACA,AACD,oCACE,gBAAiB,AACjB,kBAAoB,CACrB,AACD,kCACE,eAAiB,CAClB,AACD,iCACE,gBAAiB,AACjB,aAAe,CAChB,AACD,yBACA,kCACI,yBAA2B,CAC9B,CACA,AACD,yBACA,iCACI,sBAAuB,AACvB,6BAAgC,CACnC,AACD,iCACI,YAAa,AACb,iBAAmB,CACtB,AACD,kCACI,cAAgB,CACnB,CACA,AACD,sCACE,gBAAiB,AACjB,sCAAuC,AACvC,mCAAoC,AACpC,iBAAmB,CACpB,AACD,4CACE,kBAAmB,AACnB,kBAAmB,AACnB,+BAAkC,AAClC,aAAc,AACd,kBAAmB,AACnB,wBAA0B,AAC1B,eAAgB,AAChB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,kDACE,0BAA4B,CAC7B,AACD,mDACE,WAAa,CACd,AACD,2CACE,gBAAkB,CACnB,AACD,sFAEE,qBAAuB,CACxB,AACD,2EAEE,SAAW,CACZ","file":"NominationsAdd.vue","sourcesContent":["\n.nom-add__layout[data-v-5169dbea] {\n  display: grid;\n  grid-template-columns: 3fr 1fr;\n  grid-gap: 16px;\n  padding: 0 16px 16px;\n  font-size: 1.1rem;\n}\n.biosecurity-actions__download[data-v-5169dbea] {\n  margin-left: 1rem;\n  justify-content: center;\n}\n.nom-add__actions[data-v-5169dbea] {\n  row-gap: 12px;\n}\n@media (max-width: 450px) {\n.biosecurity-actions[data-v-5169dbea] {\n    flex-direction: column;\n    align-items: stretch;\n}\n.biosecurity-actions > *[data-v-5169dbea] {\n    margin-top: 12px;\n}\n.biosecurity-actions__download[data-v-5169dbea] {\n    margin-left: 0;\n}\n}\n.nominations__item[data-v-5169dbea] {\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n.nom-add__select[data-v-5169dbea] {\n  max-width: 320px;\n}\n.nom-add__label[data-v-5169dbea] {\n  min-width: 200px;\n  flex-shrink: 0;\n}\n@media (max-width: 768px) {\n.nom-add__layout[data-v-5169dbea] {\n    grid-template-columns: 1fr;\n}\n}\n@media (max-width: 576px) {\n.nom-add__field[data-v-5169dbea] {\n    flex-direction: column;\n    align-items: stretch !important;\n}\n.nom-add__label[data-v-5169dbea] {\n    min-width: 0;\n    margin-bottom: 6px;\n}\n.nom-add__select[data-v-5169dbea] {\n    max-width: none;\n}\n}\n.horse-order-preview[data-v-5169dbea] {\n  max-width: 293px;\n  border: 1px solid var(--success-color);\n  background-color: var(--success-bg);\n  padding: 6px 5px 0;\n}\n.horse-order-preview__item[data-v-5169dbea] {\n  text-align: center;\n  color: var(--dark);\n  font: bold 15px Arial, sans-serif;\n  padding: 10px;\n  margin-bottom: 5px;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.horse-order-preview__item[data-v-5169dbea]:hover {\n  background: var(--gray-100);\n}\n.horse-order-preview__item[data-v-5169dbea]:active {\n  cursor: move;\n}\n.horse-order-preview__num[data-v-5169dbea] {\n  margin-right: 4px;\n}\n.banner-fade-enter-active[data-v-5169dbea],\n.banner-fade-leave-active[data-v-5169dbea] {\n  transition: opacity 1s;\n}\n.banner-fade-enter[data-v-5169dbea],\n.banner-fade-leave-to[data-v-5169dbea] {\n  opacity: 0;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1364);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("372a3914", content, true, {});

/***/ }),

/***/ 1364:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".add-nomination-container .footer{display:none}@media (max-width:568px){.add-nomination-container .footer{display:block}.add-nomination-container .footer .banner{position:fixed;bottom:0;width:100%;left:0;padding:0 16px}.add-nomination-container .footer .banner img{width:100%}}@media (max-width:768px){.nom-add__layout .desktop-banner{display:none!important}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Nominations/NominationsAdd.vue"],"names":[],"mappings":"AACA,kCACE,YAAc,CACf,AACD,yBACA,kCACI,aAAe,CAClB,AACD,0CACI,eAAgB,AAChB,SAAU,AACV,WAAY,AACZ,OAAQ,AACR,cAAgB,CACnB,AACD,8CACI,UAAY,CACf,CACA,AACD,yBACA,iCACI,sBAAyB,CAC5B,CACA","file":"NominationsAdd.vue","sourcesContent":["\n.add-nomination-container .footer {\n  display: none;\n}\n@media (max-width: 568px) {\n.add-nomination-container .footer {\n    display: block;\n}\n.add-nomination-container .footer .banner {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    left: 0;\n    padding: 0 16px;\n}\n.add-nomination-container .footer .banner img {\n    width: 100%;\n}\n}\n@media (max-width: 768px) {\n.nom-add__layout .desktop-banner {\n    display: none !important;\n}\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useNominationAdd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__composables_useFormAlert__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__composables_useUserRole__ = __webpack_require__(50);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }






function useNominationAdd(draftId) {
  var _useUserRole = Object(__WEBPACK_IMPORTED_MODULE_4__composables_useUserRole__["a" /* default */])(),
      isSecretaryMember = _useUserRole.isSecretaryMember,
      isSecretaryOrAdmin = _useUserRole.isSecretaryOrAdmin;

  var draft = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var loadFailed = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var draftEvents = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var memberSearchResults = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loadingMembers = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var selectedMember = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var byEvent = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
    eventId: null,
    selectedEvent: null,
    horses: [],
    loadingHorses: false,
    maxHorses: null,
    selectedHorseIds: []
  });
  var byHorse = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
    horses: [],
    loadingHorses: false,
    horseId: null,
    selectedHorse: null,
    events: [],
    loadingEvents: false,
    selectedEventId: null
  });
  var bySubmission = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
    events: [],
    loadingEvents: false,
    eventId: null,
    selectedEvent: null,
    quantity: 1,
    maxSubmissions: null,
    used: null,
    loadingQuantity: false
  });
  var submitting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var alert = Object(__WEBPACK_IMPORTED_MODULE_3__composables_useFormAlert__["a" /* default */])();
  var userNominations = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loadingNominations = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false); // IDs selected for bulk scratch

  var scratchSelectedIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var needsToBeProcessed = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return userNominations.value.some(function (nomination) {
      return nomination.needs_to_be_processed === true;
    });
  });

  function loadUserNominations(_x) {
    return _loadUserNominations.apply(this, arguments);
  }

  function _loadUserNominations() {
    _loadUserNominations = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(userId) {
      var silent,
          effectiveUserId,
          params,
          res,
          _args3 = arguments;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              silent = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;
              // A secretary-member always sees their own nominations here, even while
              // browsing other members' horses/events to nominate on their behalf.
              effectiveUserId = isSecretaryMember ? null : userId;
              if (!silent) loadingNominations.value = true;
              _context3.prev = 3;
              params = effectiveUserId != null ? {
                user_id: effectiveUserId
              } : {};
              _context3.next = 7;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].userNominations(draftId, params);

            case 7:
              res = _context3.sent;
              userNominations.value = res.data.data != null ? res.data.data : [];
              _context3.next = 13;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](3);

            case 13:
              _context3.prev = 13;
              if (!silent) loadingNominations.value = false;
              return _context3.finish(13);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 11, 13, 16]]);
    }));
    return _loadUserNominations.apply(this, arguments);
  }

  function init() {
    return _init.apply(this, arguments);
  }

  function _init() {
    _init = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4() {
      var draftRes, eventsRes, allEvts, subEventsRes, data, msg;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              loading.value = true;
              _context4.prev = 1;
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].draft(draftId);

            case 4:
              draftRes = _context4.sent;
              draft.value = draftRes.data.data;
              _context4.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].draftEvents(draftId);

            case 8:
              eventsRes = _context4.sent;
              allEvts = eventsRes.data.data.events != null ? eventsRes.data.data.events : [];
              draftEvents.value = allEvts;
              _context4.next = 13;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].submissionEventsForDraft(draftId);

            case 13:
              subEventsRes = _context4.sent;
              bySubmission.events = subEventsRes.data.data.events != null ? subEventsRes.data.data.events : [];
              _context4.next = 23;
              break;

            case 17:
              _context4.prev = 17;
              _context4.t0 = _context4["catch"](1);
              loadFailed.value = true;
              data = _context4.t0.response != null ? _context4.t0.response.data : null;
              msg = data != null && data.message != null ? data.message : 'Failed to load draft data. Please try again.';
              __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('http-error-persistent', msg);

            case 23:
              _context4.prev = 23;
              loading.value = false;
              return _context4.finish(23);

            case 26:
              loadUserNominations(null);

            case 27:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 17, 23, 26]]);
    }));
    return _init.apply(this, arguments);
  }

  var searchTimer = null; // The "choose the competitor to nominate for" select has two audiences:
  // - Secretary / Admin nominate on behalf of anyone -> GET /v2/nominations/members-search
  //   (whole financial roster; empty term = first page, typed term = name search).
  // - Regular members / volunteers nominate only within their own family -> GET /v2/nominations/members
  //   (loaded once; a typed term just filters that small list client-side, no request).

  function searchMembers(query) {
    var term = (query || '').trim();
    clearTimeout(searchTimer);

    if (isSecretaryOrAdmin) {
      if (term && term.length < 2) return; // backend requires q >= 2 chars

      searchTimer = setTimeout(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loadingMembers.value = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].membersSearch(term ? {
                  q: term
                } : {});

              case 4:
                res = _context.sent;
                memberSearchResults.value = res.data.data;
                _context.next = 10;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);

              case 10:
                _context.prev = 10;
                loadingMembers.value = false;
                return _context.finish(10);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8, 10, 13]]);
      })), 300);
      return;
    }

    if (memberSearchResults.value.length > 0) return; // family list already loaded; multiselect filters it

    searchTimer = setTimeout(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              loadingMembers.value = true;
              _context2.prev = 1;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].members({});

            case 4:
              res = _context2.sent;
              memberSearchResults.value = res.data.data;
              _context2.next = 10;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);

            case 10:
              _context2.prev = 10;
              loadingMembers.value = false;
              return _context2.finish(10);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8, 10, 13]]);
    })), 300);
  }

  function loadHorsesForMember(_x2) {
    return _loadHorsesForMember.apply(this, arguments);
  }

  function _loadHorsesForMember() {
    _loadHorsesForMember = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(memberId) {
      var res;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              byHorse.loadingHorses = true;
              _context5.prev = 1;
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].memberHorses(memberId);

            case 4:
              res = _context5.sent;
              byHorse.horses = res.data.data.horses != null ? res.data.data.horses : [];
              _context5.next = 10;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);

            case 10:
              _context5.prev = 10;
              byHorse.loadingHorses = false;
              return _context5.finish(10);

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 8, 10, 13]]);
    }));
    return _loadHorsesForMember.apply(this, arguments);
  }

  function setByEventEvent(_x3) {
    return _setByEventEvent.apply(this, arguments);
  }

  function _setByEventEvent() {
    _setByEventEvent = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee6(eventId) {
      var res;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              byEvent.eventId = eventId != null && eventId !== '' ? Number(eventId) : null;
              byEvent.horses = [];
              byEvent.selectedHorseIds = [];
              byEvent.maxHorses = null;

              if (!(selectedMember.value == null || byEvent.eventId == null)) {
                _context6.next = 6;
                break;
              }

              return _context6.abrupt("return");

            case 6:
              byEvent.loadingHorses = true;
              _context6.prev = 7;
              _context6.next = 10;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].memberHorses(selectedMember.value.id, {
                event_id: byEvent.eventId
              });

            case 10:
              res = _context6.sent;
              byEvent.horses = res.data.data.horses != null ? res.data.data.horses : [];
              byEvent.maxHorses = res.data.data.max_horses != null ? res.data.data.max_horses : null;
              _context6.next = 17;
              break;

            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6["catch"](7);

            case 17:
              _context6.prev = 17;
              byEvent.loadingHorses = false;
              return _context6.finish(17);

            case 20:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[7, 15, 17, 20]]);
    }));
    return _setByEventEvent.apply(this, arguments);
  }

  function setBySubmissionEvent(_x4) {
    return _setBySubmissionEvent.apply(this, arguments);
  }

  function _setBySubmissionEvent() {
    _setBySubmissionEvent = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee7(eventId) {
      var res;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              bySubmission.eventId = eventId != null && eventId !== '' ? Number(eventId) : null;
              bySubmission.maxSubmissions = null;
              bySubmission.used = null;
              bySubmission.quantity = 1;

              if (!(selectedMember.value == null || bySubmission.eventId == null)) {
                _context7.next = 6;
                break;
              }

              return _context7.abrupt("return");

            case 6:
              bySubmission.loadingQuantity = true;
              _context7.prev = 7;
              _context7.next = 10;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].submissionQuantityForMember(selectedMember.value.id, {
                event_id: bySubmission.eventId
              });

            case 10:
              res = _context7.sent;
              bySubmission.maxSubmissions = res.data.data.max_submissions != null ? res.data.data.max_submissions : null;
              bySubmission.used = res.data.data.used != null ? res.data.data.used : 0;
              _context7.next = 17;
              break;

            case 15:
              _context7.prev = 15;
              _context7.t0 = _context7["catch"](7);

            case 17:
              _context7.prev = 17;
              bySubmission.loadingQuantity = false;
              return _context7.finish(17);

            case 20:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[7, 15, 17, 20]]);
    }));
    return _setBySubmissionEvent.apply(this, arguments);
  }

  function setMember(member) {
    selectedMember.value = member;
    byEvent.horses = [];
    byEvent.selectedHorseIds = [];
    byEvent.maxHorses = null;
    byHorse.horseId = null;
    byHorse.selectedHorse = null;
    byHorse.events = [];
    bySubmission.maxSubmissions = null;
    bySubmission.used = null;
    bySubmission.quantity = 1;
    var userId = member != null ? member.id : null;
    loadUserNominations(userId, true);

    if (member == null) {
      byHorse.horses = [];
      return;
    }

    if (byEvent.eventId != null) {
      setByEventEvent(byEvent.eventId);
    }

    if (bySubmission.eventId != null) {
      setBySubmissionEvent(bySubmission.eventId);
    }

    loadHorsesForMember(member.id);
  }

  function toggleHorse(horseId) {
    var idx = byEvent.selectedHorseIds.indexOf(horseId);

    if (idx === -1) {
      byEvent.selectedHorseIds = [].concat(_toConsumableArray(byEvent.selectedHorseIds), [horseId]);
    } else {
      byEvent.selectedHorseIds = byEvent.selectedHorseIds.filter(function (id) {
        return id !== horseId;
      });
    }
  }

  function setByHorseHorse(_x5) {
    return _setByHorseHorse.apply(this, arguments);
  }

  function _setByHorseHorse() {
    _setByHorseHorse = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee8(horseId) {
      var res, allEvts;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              byHorse.horseId = horseId != null && horseId !== '' ? Number(horseId) : null;
              byHorse.events = [];
              byHorse.selectedEventId = null;

              if (!(byHorse.horseId == null)) {
                _context8.next = 5;
                break;
              }

              return _context8.abrupt("return");

            case 5:
              byHorse.loadingEvents = true;
              _context8.prev = 6;
              _context8.next = 9;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].horseEvents(byHorse.horseId, {
                draft_id: draftId
              });

            case 9:
              res = _context8.sent;
              allEvts = res.data.data.events != null ? res.data.data.events : [];
              byHorse.events = allEvts;
              _context8.next = 16;
              break;

            case 14:
              _context8.prev = 14;
              _context8.t0 = _context8["catch"](6);

            case 16:
              _context8.prev = 16;
              byHorse.loadingEvents = false;
              return _context8.finish(16);

            case 19:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[6, 14, 16, 19]]);
    }));
    return _setByHorseHorse.apply(this, arguments);
  }

  function extractError(err) {
    var data = err.response != null ? err.response.data : null;
    return data != null && data.message != null ? data.message : 'A server error occurred. Please try again later.';
  }

  function submit(_x6) {
    return _submit.apply(this, arguments);
  }

  function _submit() {
    _submit = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee9(activeTab) {
      var res, msg, eventId, horseIds, _res, _msg;

      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (!(selectedMember.value == null)) {
                _context9.next = 2;
                break;
              }

              return _context9.abrupt("return", false);

            case 2:
              alert.clear();

              if (!(activeTab === 'submission')) {
                _context9.next = 26;
                break;
              }

              submitting.value = true;
              _context9.prev = 5;
              _context9.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].storeSubmission({
                draft_id: Number(draftId),
                user_id: selectedMember.value.id,
                event_id: bySubmission.eventId,
                quantity: bySubmission.quantity
              });

            case 8:
              res = _context9.sent;
              _context9.next = 11;
              return loadUserNominations(selectedMember.value.id, true);

            case 11:
              if (!(bySubmission.eventId != null)) {
                _context9.next = 14;
                break;
              }

              _context9.next = 14;
              return setBySubmissionEvent(bySubmission.eventId);

            case 14:
              msg = res.data.message != null ? res.data.message : 'Nomination saved successfully.';
              __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('show-success', msg);
              return _context9.abrupt("return", true);

            case 19:
              _context9.prev = 19;
              _context9.t0 = _context9["catch"](5);
              alert.showError(extractError(_context9.t0));
              return _context9.abrupt("return", false);

            case 23:
              _context9.prev = 23;
              submitting.value = false;
              return _context9.finish(23);

            case 26:
              eventId = activeTab === 'event' ? byEvent.eventId : byHorse.selectedEventId;
              horseIds = activeTab === 'event' ? byEvent.selectedHorseIds : [byHorse.horseId];
              submitting.value = true;
              _context9.prev = 29;
              _context9.next = 32;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].create({
                draft_id: Number(draftId),
                user_id: selectedMember.value.id,
                event_id: eventId,
                horse_ids: horseIds
              });

            case 32:
              _res = _context9.sent;

              if (activeTab === 'event') {
                byEvent.selectedHorseIds = [];
              } else {
                byHorse.selectedEventId = null;
              }

              _context9.next = 36;
              return loadUserNominations(selectedMember.value.id, true);

            case 36:
              _msg = _res.data.message != null ? _res.data.message : 'Nomination saved successfully.';
              __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('show-success', _msg);
              return _context9.abrupt("return", true);

            case 41:
              _context9.prev = 41;
              _context9.t1 = _context9["catch"](29);
              alert.showError(extractError(_context9.t1));
              return _context9.abrupt("return", false);

            case 45:
              _context9.prev = 45;
              submitting.value = false;
              return _context9.finish(45);

            case 48:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[5, 19, 23, 26], [29, 41, 45, 48]]);
    }));
    return _submit.apply(this, arguments);
  }

  function deleteNomination(_x7) {
    return _deleteNomination.apply(this, arguments);
  }

  function _deleteNomination() {
    _deleteNomination = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee10(nomId) {
      var res, userId;
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].deleteNomination(nomId);

            case 2:
              res = _context10.sent;
              userId = selectedMember.value != null ? selectedMember.value.id : null;
              _context10.next = 6;
              return loadUserNominations(userId, true);

            case 6:
              return _context10.abrupt("return", res);

            case 7:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    return _deleteNomination.apply(this, arguments);
  }

  function bulkScratch() {
    return _bulkScratch.apply(this, arguments);
  }

  function _bulkScratch() {
    _bulkScratch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee11() {
      var res, userId;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!(scratchSelectedIds.value.length === 0)) {
                _context11.next = 2;
                break;
              }

              return _context11.abrupt("return", null);

            case 2:
              _context11.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].bulkScratch({
                nomination_ids: scratchSelectedIds.value
              });

            case 4:
              res = _context11.sent;
              scratchSelectedIds.value = [];
              userId = selectedMember.value != null ? selectedMember.value.id : null;
              _context11.next = 9;
              return loadUserNominations(userId, true);

            case 9:
              return _context11.abrupt("return", res);

            case 10:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
    return _bulkScratch.apply(this, arguments);
  }

  function updateNominationRider(_x8, _x9) {
    return _updateNominationRider.apply(this, arguments);
  }

  function _updateNominationRider() {
    _updateNominationRider = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee12(nomId, userMemberId) {
      var userId;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].updateNomination(nomId, {
                user_member_id: userMemberId
              });

            case 3:
              userId = selectedMember.value != null ? selectedMember.value.id : null;
              _context12.next = 6;
              return loadUserNominations(userId, true);

            case 6:
              _context12.next = 11;
              break;

            case 8:
              _context12.prev = 8;
              _context12.t0 = _context12["catch"](0);
              __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('show-error', extractError(_context12.t0));

            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[0, 8]]);
    }));
    return _updateNominationRider.apply(this, arguments);
  }

  function updateNominationHorse(_x10, _x11) {
    return _updateNominationHorse.apply(this, arguments);
  }

  function _updateNominationHorse() {
    _updateNominationHorse = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee13(nomId, horseId) {
      var userId;
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].updateNomination(nomId, {
                horse_id: horseId
              });

            case 3:
              userId = selectedMember.value != null ? selectedMember.value.id : null;
              _context13.next = 6;
              return loadUserNominations(userId, true);

            case 6:
              _context13.next = 11;
              break;

            case 8:
              _context13.prev = 8;
              _context13.t0 = _context13["catch"](0);
              __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('show-error', extractError(_context13.t0));

            case 11:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[0, 8]]);
    }));
    return _updateNominationHorse.apply(this, arguments);
  }

  function reorderNominations(_x12) {
    return _reorderNominations.apply(this, arguments);
  }

  function _reorderNominations() {
    _reorderNominations = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee14(items) {
      return regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].reorderNominations({
                items: items
              }));

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));
    return _reorderNominations.apply(this, arguments);
  }

  function toggleScratchSelect(nomId) {
    var idx = scratchSelectedIds.value.indexOf(nomId);

    if (idx === -1) {
      scratchSelectedIds.value = [].concat(_toConsumableArray(scratchSelectedIds.value), [nomId]);
    } else {
      scratchSelectedIds.value = scratchSelectedIds.value.filter(function (id) {
        return id !== nomId;
      });
    }
  }

  function toggleSelectAll(allIds) {
    if (scratchSelectedIds.value.length === allIds.length) {
      scratchSelectedIds.value = [];
    } else {
      scratchSelectedIds.value = _toConsumableArray(allIds);
    }
  }

  return {
    draft: draft,
    loading: loading,
    loadFailed: loadFailed,
    draftEvents: draftEvents,
    memberSearchResults: memberSearchResults,
    loadingMembers: loadingMembers,
    selectedMember: selectedMember,
    byEvent: byEvent,
    byHorse: byHorse,
    bySubmission: bySubmission,
    submitting: submitting,
    alert: alert,
    userNominations: userNominations,
    loadingNominations: loadingNominations,
    scratchSelectedIds: scratchSelectedIds,
    needsToBeProcessed: needsToBeProcessed,
    init: init,
    searchMembers: searchMembers,
    setMember: setMember,
    setByEventEvent: setByEventEvent,
    toggleHorse: toggleHorse,
    setByHorseHorse: setByHorseHorse,
    setBySubmissionEvent: setBySubmissionEvent,
    submit: submit,
    deleteNomination: deleteNomination,
    bulkScratch: bulkScratch,
    updateNominationRider: updateNominationRider,
    updateNominationHorse: updateNominationHorse,
    reorderNominations: reorderNominations,
    toggleScratchSelect: toggleScratchSelect,
    toggleSelectAll: toggleSelectAll,
    loadUserNominations: loadUserNominations
  };
}

/***/ }),

/***/ 1366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationsAddList_vue__ = __webpack_require__(1255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_757ef006_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationsAddList_vue__ = __webpack_require__(1369);
function injectStyle (ssrContext) {
  __webpack_require__(1367)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-757ef006"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationsAddList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_757ef006_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationsAddList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1368);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("072d6016", content, true, {});

/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".badge-combined[data-v-757ef006]{background-color:var(--primary);color:var(--white)}.nom-row--even[data-v-757ef006]{background-color:var(--white)}.nom-row--odd[data-v-757ef006]{background-color:var(--gray-75)}.review_all_nominations .icon-btn--drag[data-v-757ef006]{display:block;width:40px;flex-shrink:0}.review_all_nominations[data-v-757ef006] .form-control{margin-top:0}.quantity_cell[data-v-757ef006]{display:flex;align-items:center}.quantity_input[data-v-757ef006]{max-width:100px}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Nominations/components/NominationsAddList.vue"],"names":[],"mappings":"AACA,iCACE,gCAAiC,AACjC,kBAAoB,CACrB,AACD,gCACE,6BAA+B,CAChC,AACD,+BACE,+BAAiC,CAClC,AACD,yDACE,cAAe,AACf,WAAY,AACZ,aAAe,CAChB,AACD,uDACE,YAAc,CACf,AACD,gCACE,aAAc,AACd,kBAAoB,CACrB,AACD,iCACE,eAAiB,CAClB","file":"NominationsAddList.vue","sourcesContent":["\n.badge-combined[data-v-757ef006] {\n  background-color: var(--primary);\n  color: var(--white);\n}\n.nom-row--even[data-v-757ef006] {\n  background-color: var(--white);\n}\n.nom-row--odd[data-v-757ef006] {\n  background-color: var(--gray-75);\n}\n.review_all_nominations .icon-btn--drag[data-v-757ef006] {\n  display: block;\n  width: 40px;\n  flex-shrink: 0;\n}\n.review_all_nominations[data-v-757ef006] .form-control {\n  margin-top: 0;\n}\n.quantity_cell[data-v-757ef006] {\n  display: flex;\n  align-items: center;\n}\n.quantity_input[data-v-757ef006] {\n  max-width: 100px;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"review_all_nominations px-3 pb-3"},[_c('strong',{staticClass:"review_all_nominations_title h3"},[_vm._v("All nominations in draft")]),_vm._v(" "),(_vm.loadingNominations)?_c('div',{staticClass:"text-center py-3"},[_vm._m(0)]):(_vm.groupedNominations.length > 0)?[_c('div',{staticClass:"alert alert-success custom-alert-success mt-2"},[_vm._v("\n      No further action is required for your held nominations. You'll be notified, via email, when the committee finalises nominations\n    ")]),_vm._v(" "),_c('form-alert',{staticClass:"mb-2",attrs:{"message":_vm.scratchAlert.message.value,"type":_vm.scratchAlert.type.value}}),_vm._v(" "),_c('bulk-editor-tool',{attrs:{"total-count":_vm.allNomIds.length,"selected-count":_vm.scratchSelectedIds.length},on:{"toggle-all":_vm.toggleSelectAll}},[_c('app-button',{attrs:{"type":"button","variant":"outline-primary","block":false},on:{"click":function($event){_vm.scratchConfirmPending = true}}},[_vm._v("\n        Scratch\n      ")])],1),_vm._v(" "),_vm._l((_vm.groupedNominations),function(group){return _c('div',{key:group.event.id,staticClass:"mt-3"},[_c('div',{staticClass:"event_info mb-2 pl-2"},[_c('div',[_c('strong',[_vm._v(_vm._s(group.event.name))])]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Price for one nomination - $"+_vm._s(group.event.cost))]),_vm._v(" "),(group.event.discount_price)?_c('strong',[_vm._v(" ($"+_vm._s(group.event.discount_price)+" for one with the discount applied)")]):_vm._e()]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Total price for all your nominations in the event - $"+_vm._s(group.totalPrice))])])]),_vm._v(" "),_c('form-alert',{staticClass:"mb-2",attrs:{"message":_vm.getGroupAlert(group.event.id).message.value,"type":_vm.getGroupAlert(group.event.id).type.value}}),_vm._v(" "),_c('div',{staticClass:"cut-table table-hover table-nominations"},[_c('div',{staticClass:"cut-table__header"},[_c('ul',{staticClass:"cut-table__row row m-0"},[_vm._m(1,true),_vm._v(" "),_c('li',{staticClass:"cut-table__cell col-md-4"},[_c('strong',[_vm._v(_vm._s(group.isNoHorse ? 'Quantity' : 'Horse name'))])]),_vm._v(" "),_vm._m(2,true),_vm._v(" "),_vm._m(3,true)])]),_vm._v(" "),_c('div',{staticClass:"cut-table__body"},[_vm._l((group.memberGroups),function(memberGroup){return [_c('draggable',{key:memberGroup.rider.id,attrs:{"tag":"div","handle":".icon-btn--drag","list":memberGroup.nominations,"group":{ name: 'member-' + memberGroup.rider.id, pull: false, put: false }},on:{"update":function($event){return _vm.onDragEnd(memberGroup.nominations, group.event.id)}}},_vm._l((memberGroup.nominations),function(nom){return _c('ul',{key:nom.id,class:['cut-table__row', 'nominations_added_list', 'row', 'm-0', memberGroup.colorIndex % 2 === 0 ? 'nom-row--even' : 'nom-row--odd']},[_c('li',{staticClass:"cut-table__cell member_name col-12 col-md-4"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('f-checkbox',{staticClass:"mb-0 mr-1",attrs:{"id":("nom-check-" + (nom.id)),"label":"","value":_vm.scratchSelectedIds.indexOf(nom.id) !== -1},on:{"input":function($event){return _vm.toggleScratchSelect(nom.id)}}}),_vm._v(" "),_c('span',{staticClass:"icon-btn icon-btn--drag",attrs:{"title":"Drag to reorder"}}),_vm._v(" "),_c('div',{staticClass:"form-group mb-0 flex-grow-1"},[_c('multiselect',{attrs:{"value":_vm.riderOverrides[nom.id] != null ? _vm.riderOverrides[nom.id] : _vm.riderForNom(nom),"options":_vm.membersByNom[nom.id] || [],"label":"full_name","track-by":"id","placeholder":"Select member...","select-label":"","deselect-label":"","selected-label":""},on:{"open":function($event){return _vm.loadMembersForNom(nom.id, nom.horse.id)},"input":function($event){return _vm.onRiderSelect(nom.id, $event, group.event.id)}}})],1)],1)]),_vm._v(" "),(nom.horse.id != null)?_c('li',{staticClass:"cut-table__cell horse_name col-12 col-md-4"},[_c('multiselect',{attrs:{"value":_vm.horseOverrides[nom.id] != null ? _vm.horseOverrides[nom.id] : nom.horse,"options":_vm.horseOptionsForNom(nom.id, nom.horse.id),"label":"name","track-by":"id","placeholder":"Select horse...","select-label":"","deselect-label":"","selected-label":""},on:{"open":function($event){return _vm.loadHorsesForNom(nom.id, nom.rider.id, group.event.id)},"input":function($event){return _vm.onHorseSelect(nom.id, $event, group.event.id)}},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var option = ref.option;
return [_c('span',{class:{ 'text-muted': option.disabled }},[_vm._v("\n                        "+_vm._s(option.name)+"\n                        "),(option.disabled_reason)?_c('small',{staticClass:"d-block",staticStyle:{"font-size":"0.75em","line-height":"1.2"}},[_vm._v(_vm._s(option.disabled_reason))]):_vm._e()])]}}],null,true)})],1):_c('li',{staticClass:"cut-table__cell horse_name quantity_cell col-12 col-md-4"},[_c('input',{staticClass:"form-control quantity_input",attrs:{"type":"number","min":"1","max":_vm.quantityMaxByNomId[nom.id],"disabled":_vm.quantityUpdatingIds.indexOf(nom.id) !== -1},domProps:{"value":_vm.quantityOverrides[nom.id] != null ? _vm.quantityOverrides[nom.id] : nom.quantity},on:{"change":function($event){return _vm.onQuantityChange(nom.id, $event.target.value, group.event.id)}}})]),_vm._v(" "),_c('li',{staticClass:"cut-table__cell col-6 col-md-2 nomination_status"},[_c('span',{staticClass:"badge ml-1 my-auto alert-info text-capitalize"},[_vm._v(_vm._s(nom.status))]),_vm._v(" "),(_vm.combinedGroupNumbers[nom.id] != null)?_c('span',{staticClass:"badge badge-combined ml-1 my-auto"},[_vm._v("\n                    Combined #"+_vm._s(_vm.combinedGroupNumbers[nom.id])+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"cut-table__cell col-6 col-md-2 d-flex action_remove"},[_c('div',{staticClass:"actions__draft _type-delete"},[_c('app-button',{staticClass:"icon-btn icon-btn--delete p-0",attrs:{"variant":"link","block":false},on:{"click":function($event){_vm.deleteConfirmPending = { nomId: nom.id, eventId: group.event.id }}}})],1)])])}),0)]})],2)])],1)})]:_c('strong',{staticClass:"d-block mt-2"},[_vm._v("No nomination is found")]),_vm._v(" "),(_vm.scratchConfirmPending)?_c('confirm-modal',{attrs:{"message":"Are you sure you want to scratch selected nominations?"},on:{"confirm":_vm.handleBulkScratch,"cancel":function($event){_vm.scratchConfirmPending = false}}}):_vm._e(),_vm._v(" "),(_vm.deleteConfirmPending)?_c('confirm-modal',{attrs:{"message":"Are you sure you want to delete the nomination?"},on:{"confirm":_vm.handleDelete,"cancel":function($event){_vm.deleteConfirmPending = null}}}):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border spinner-border-sm text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"cut-table__cell col-md-4"},[_c('strong',[_vm._v("Competitor name")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"cut-table__cell col-md-2"},[_c('strong',[_vm._v("Status")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"cut-table__cell col-md-2"},[_c('strong',[_vm._v("Scratch")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"add-nomination-container",style:(_vm.appearances.schema_color 
      ? { 
        '--primary': _vm.appearances.schema_color,  
        '--primary-dark': _vm.appearances.schema_color,
        '--primary-rgb': _vm.appearances.schema_color,
      } : null),attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('div',{staticClass:"leaderboard nominate bg-white rounded mb-4"},[_c('div',{staticClass:"p-3"},[_c('page-heading',[_vm._v("Nominate for "+_vm._s(_vm.draft ? _vm.draft.name : ''))]),_vm._v(" "),_c('appearances-drafts-header',{attrs:{"appearances":_vm.appearances}})],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-center py-5"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):(!_vm.loadFailed)?[(_vm.draft && _vm.draft.settings && _vm.draft.settings.is_show_biosecurity_form)?_c('div',{staticClass:"mt-2 mb-3 px-3"},[_c('div',{staticClass:"d-flex h5"},[_vm._v("Biosecurity Form")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap biosecurity-actions"},[_c('router-link',{staticClass:"btn btn-primary btn-sm",attrs:{"to":("/biosecurity/" + (_vm.draft.id))}},[_vm._v("\n                  Fill Online\n                ")]),_vm._v(" "),_c('app-button',{staticClass:"d-flex align-items-center biosecurity-actions__download",attrs:{"type":"button","variant":"outline-primary","size":"sm","block":false,"loading":_vm.downloadingBlankForm},on:{"click":_vm.downloadBlankForm}},[_c('svg',{staticClass:"mr-2",attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 10.133c-.107 0-.32 0-.427-.107L4.373 6.827a.52.52 0 010-.747.52.52 0 01.747 0L7.893 8.853l2.774-2.773a.52.52 0 01.746 0 .52.52 0 010 .747L8.213 10.026c.107.107-.107.107-.213.107z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 9.6c-.32 0-.533-.213-.533-.533V.533C7.467.213 7.68 0 8 0c.32 0 .533.213.533.533v8.534c0 .32-.213.533-.533.533z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.333 16H2.667C1.173 16 0 14.827 0 13.333V11.2c0-.32.213-.533.533-.533.32 0 .534.213.534.533v2.133c0 .854.746 1.6 1.6 1.6h10.666c.854 0 1.6-.746 1.6-1.6V11.2c0-.32.214-.533.534-.533.32 0 .533.213.533.533v2.133C16 14.827 14.827 16 13.333 16z","fill":"currentColor"}})]),_vm._v("Download Blank Form")])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter mb-0 px-3"},[_c('app-tab-switcher',{attrs:{"items":_vm.tabItems,"value":_vm.activeTab,"color":_vm.appearances.schema_color || null},on:{"input":function($event){_vm.activeTab = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"nom-add__layout nom-add__layout--with-banner mt-3"},[_c('div',{staticClass:"nominations p-3 bg-lighter border-top nom-add__forms"},[(_vm.$isSecretaryOrAdmin)?_c('div',{staticClass:"alert alert-info alert-simple"},[_vm._v("\n              As a secretary you're able to nominate for all members in the ACA database.\n              If you can't find the member you're nominating for, click\n              "),_c('router-link',{attrs:{"to":{ name: 'Members' }}},[_vm._v("HERE")]),_vm._v("\n              to check if they're financial.\n            ")],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'event' && _vm.hasNoHorseEvents)?_c('div',{staticClass:"alert alert-info alert-simple",attrs:{"role":"alert"}},[_vm._v("\n              If you can’t find what you’re looking for here – and for events like judges seminars, clinics, meals, special awards and stables – try looking under the\n              "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.activeTab = 'submission'}}},[_vm._v("“No horse required”")]),_vm._v(" tab.\n            ")]):_vm._e(),_vm._v(" "),(_vm.draft)?_c('div',{staticClass:"wrap-nominations-item"},[_c('div',{staticClass:"nominations__item"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Draft Start Date:")]),_vm._v(" "),_c('span',{staticClass:"nominations__item-date ml-2"},[_vm._v(_vm._s(_vm.formatDate(_vm.draft.start_date)))])]),_vm._v(" "),_c('div',{staticClass:"nominations__item"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Noms Open till:")]),_vm._v(" "),_c('span',{staticClass:"nominations__item-date ml-2"},[_vm._v(_vm._s(_vm.formatDate(_vm.draft.noms_closed)))])]),_vm._v(" "),(_vm.draft.settings && _vm.draft.settings.event_members_allowed)?_c('div',{staticClass:"nominations__item"},[_vm._v("\n                Event members: allowed\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nominations__item"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("First Round Runs Per Person:")]),_vm._v(" "),_c('span',{staticClass:"nominations__item-date ml-2"},[_vm._v(_vm._s(_vm.draft.settings && _vm.draft.settings.first_round_runs_per_person != null ? _vm.draft.settings.first_round_runs_per_person : 'Unlimited'))])]),_vm._v(" "),_c('div',{staticClass:"nominations__item"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Total Runs Per Horse:")]),_vm._v(" "),_c('span',{staticClass:"nominations__item-date ml-2"},[_vm._v(_vm._s(_vm.draft.settings && _vm.draft.settings.total_runs_per_horse != null ? _vm.draft.settings.total_runs_per_horse : 'Unlimited'))])])]):_vm._e(),_vm._v(" "),(_vm.needsToBeProcessed && _vm.draft)?_c('div',{staticClass:"alert alert-warning needs_to_be_processed_message mt-2"},[_vm._v("\n              Due to excessive nominations "+_vm._s(_vm.draft.name)+" restrictions have been changed."),_c('br'),_vm._v(" "),(_vm.draft.settings.previous_first_round_runs_per_person != null && _vm.draft.settings.previous_first_round_runs_per_person !== _vm.draft.settings.first_round_runs_per_person)?[_vm._v("\n                First round runs per person changed from "+_vm._s(_vm.draft.settings.previous_first_round_runs_per_person)+" to "+_vm._s(_vm.draft.settings.first_round_runs_per_person)+"."),_c('br')]:_vm._e(),_vm._v(" "),(_vm.draft.settings.previous_total_runs_per_horse != null && _vm.draft.settings.previous_total_runs_per_horse !== _vm.draft.settings.total_runs_per_horse)?[_vm._v("\n                Total runs per horse changed from "+_vm._s(_vm.draft.settings.previous_total_runs_per_horse)+" to "+_vm._s(_vm.draft.settings.total_runs_per_horse)+"."),_c('br')]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group wrap-custom-select _type-add-horse-select nom-add__field d-flex align-items-start"},[_c('label',{staticClass:"font-weight-bold mr-3 nom-add__label"},[_vm._v("Choose the competitor"),_c('br'),_vm._v("to nominate for")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 nom-add__select"},[_c('multiselect',{attrs:{"options":_vm.memberSearchResults,"loading":_vm.loadingMembers,"label":"full_name","track-by":"id","placeholder":"Search member...","select-label":"","deselect-label":"","selected-label":""},on:{"open":_vm.onMemberOpen,"search-change":_vm.searchMembers,"input":_vm.onMemberInput},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
      var option = ref.option;
return [_vm._v("\n                    "+_vm._s(option.full_name)),(_vm.$isSecretaryOrAdmin && _vm.memberVolunteerNote(option))?_c('span',{staticClass:"text-muted"},[_vm._v(" ("+_vm._s(_vm.memberVolunteerNote(option))+")")]):_vm._e()]}},{key:"option",fn:function(ref){
      var option = ref.option;
return [_vm._v("\n                    "+_vm._s(option.full_name)),(_vm.$isSecretaryOrAdmin && _vm.memberVolunteerNote(option))?_c('span',{staticClass:"text-muted"},[_vm._v(" ("+_vm._s(_vm.memberVolunteerNote(option))+")")]):_vm._e()]}},{key:"noResult",fn:function(){return [_vm._v("No results found.")]},proxy:true}]),model:{value:(_vm.selectedMember),callback:function ($$v) {_vm.selectedMember=$$v},expression:"selectedMember"}})],1)]),_vm._v(" "),(_vm.activeTab === 'event')?[_c('div',{staticClass:"form-group wrap-custom-select _type-add-horse-select nom-add__field d-flex"},[_c('label',{staticClass:"font-weight-bold mr-3 nom-add__label"},[_vm._v("Choose the event")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 nom-add__select"},[_c('multiselect',{attrs:{"options":_vm.draftEvents,"label":"name","track-by":"id","placeholder":"Select event...","select-label":"","deselect-label":"","selected-label":""},on:{"input":_vm.onByEventEventInput},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
      var option = ref.option;
return [_vm._v(_vm._s(option.name)+" — $"+_vm._s(option.cost))]}},{key:"option",fn:function(ref){
      var option = ref.option;
return [_vm._v(_vm._s(option.name)+" — $"+_vm._s(option.cost))]}},{key:"noResult",fn:function(){return [_vm._v("No events found.")]},proxy:true}],null,false,2689897516),model:{value:(_vm.byEvent.selectedEvent),callback:function ($$v) {_vm.$set(_vm.byEvent, "selectedEvent", $$v)},expression:"byEvent.selectedEvent"}})],1)]),_vm._v(" "),_c('div',{staticClass:"nominations__item"},[_c('span',{staticClass:"nominations__item-title font-weight-bold"},[_vm._v("Max runs per event:")]),_vm._v(" "),_c('span',{staticClass:"nominations__item-date ml-2"},[(_vm.byEvent.eventId)?[_vm._v("\n                    "+_vm._s(_vm.byEvent.maxHorses != null ? _vm.byEvent.maxHorses : '—')+"\n                  ")]:[_vm._v("Choose the event")]],2)]),_vm._v(" "),_c('div',{staticClass:"form-group wrap-added-item mt-2"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("Choose the horses")]),_vm._v(" "),(_vm.byEvent.loadingHorses)?_c('div',{staticClass:"text-muted"},[_c('span',{staticClass:"spinner-border spinner-border-sm mr-1"}),_vm._v("\n                  Loading horses...\n                ")]):(_vm.byEvent.eventId && _vm.byEvent.horses.length === 0 && _vm.selectedMember)?_c('div',{staticClass:"text-muted"},[_vm._v("\n                  No eligible horses found for this event.\n                ")]):_c('div',{staticClass:"available-horses"},_vm._l((_vm.byEvent.horses),function(horse){return _c('app-tooltip',{key:horse.id,attrs:{"text":horse.disabled_reason || ''}},[_c('f-checkbox',{attrs:{"id":("by-event-horse-" + (horse.id)),"label":horse.name,"value":_vm.byEvent.selectedHorseIds.indexOf(horse.id) !== -1,"font-normal":true,"disabled":!!horse.disabled},on:{"input":function($event){return _vm.onHorseToggle(horse.id)}}})],1)}),1),_vm._v(" "),(_vm.orderedSelectedHorses.length > 0)?_c('div',{staticClass:"horse-order-preview mt-3"},[_c('draggable',{attrs:{"list":_vm.orderedSelectedHorses},on:{"end":_vm.onPreviewDragEnd}},_vm._l((_vm.orderedSelectedHorses),function(horse,index){return _c('div',{key:horse.id,staticClass:"horse-order-preview__item"},[_c('span',{staticClass:"horse-order-preview__num"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "+_vm._s(horse.name)+"\n                    ")])}),0)],1):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.activeTab === 'horse')?[_c('div',{staticClass:"form-group wrap-custom-select _type-add-horse-select nom-add__field d-flex align-items-center"},[_c('label',{staticClass:"font-weight-bold mr-3 nom-add__label"},[_vm._v("Choose the horse")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 nom-add__select"},[_c('multiselect',{attrs:{"options":_vm.byHorse.horses,"loading":_vm.byHorse.loadingHorses,"disabled":!_vm.selectedMember,"label":"name","track-by":"id","placeholder":"Select horse...","select-label":"","deselect-label":"","selected-label":""},on:{"input":_vm.onByHorseHorseInput},scopedSlots:_vm._u([{key:"noResult",fn:function(){return [_vm._v("No horses found.")]},proxy:true}],null,false,3083968796),model:{value:(_vm.byHorse.selectedHorse),callback:function ($$v) {_vm.$set(_vm.byHorse, "selectedHorse", $$v)},expression:"byHorse.selectedHorse"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group wrap-added-item mt-2"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("Choose the event")]),_vm._v(" "),(_vm.byHorse.loadingEvents)?_c('div',{staticClass:"text-muted"},[_c('span',{staticClass:"spinner-border spinner-border-sm mr-1"}),_vm._v("\n                  Loading events...\n                ")]):(_vm.byHorse.horseId && _vm.byHorse.events.length === 0)?_c('div',{staticClass:"text-muted"},[_vm._v("\n                  No eligible events found for this horse.\n                ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.byHorse.events),function(ev){return _c('app-tooltip',{key:ev.id,staticClass:"mb-2",attrs:{"text":_vm.eventNomTooltip(ev)}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.byHorse.selectedEventId),expression:"byHorse.selectedEventId"}],staticClass:"custom-control-input",attrs:{"id":("by-horse-event-" + (ev.id)),"type":"radio","disabled":!!ev.nominated || !!ev.nominated_in_combined,"name":"byHorseEvent"},domProps:{"value":ev.id,"checked":_vm._q(_vm.byHorse.selectedEventId,ev.id)},on:{"change":function($event){return _vm.$set(_vm.byHorse, "selectedEventId", ev.id)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":("by-horse-event-" + (ev.id))}},[_vm._v("\n                      "+_vm._s(ev.name)+" — $"+_vm._s(ev.cost)+"\n                    ")])])])})],2)]:_vm._e(),_vm._v(" "),(_vm.activeTab === 'submission')?[_c('div',{staticClass:"form-group wrap-custom-select _type-add-horse-select nom-add__field d-flex"},[_c('label',{staticClass:"font-weight-bold mr-3 nom-add__label"},[_vm._v("Choose the event")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 nom-add__select"},[_c('multiselect',{attrs:{"options":_vm.bySubmission.events,"label":"name","track-by":"id","placeholder":"Select event...","select-label":"","deselect-label":"","selected-label":""},on:{"input":_vm.onBySubmissionEventInput},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
      var option = ref.option;
return [_vm._v(_vm._s(option.name)+" — $"+_vm._s(option.cost))]}},{key:"option",fn:function(ref){
      var option = ref.option;
return [_vm._v(_vm._s(option.name)+" — $"+_vm._s(option.cost))]}},{key:"noResult",fn:function(){return [_vm._v("No events found.")]},proxy:true}],null,false,2689897516),model:{value:(_vm.bySubmission.selectedEvent),callback:function ($$v) {_vm.$set(_vm.bySubmission, "selectedEvent", $$v)},expression:"bySubmission.selectedEvent"}})],1)]),_vm._v(" "),_c('div',{staticClass:"nominations__item"},[_c('span',{staticClass:"nominations__item-title font-weight-bold"},[_vm._v("Maximum Submissions Per Person:")]),_vm._v(" "),_c('span',{staticClass:"nominations__item-date ml-2"},[(_vm.bySubmission.eventId)?[(_vm.bySubmission.maxSubmissions != null)?[_vm._v("\n                      "+_vm._s(_vm.bySubmission.used)+" / "+_vm._s(_vm.bySubmission.maxSubmissions)+" used\n                    ")]:[_vm._v("Unlimited")]]:[_vm._v("Choose the event")]],2)]),_vm._v(" "),_c('div',{staticClass:"form-group wrap-added-item mt-2",staticStyle:{"max-width":"200px"}},[_c('f-text',{attrs:{"id":"submission-quantity","label":"Quantity","type":"number","min":"1","max":_vm.submissionMaxQuantity,"disabled":!_vm.bySubmission.eventId,"value":_vm.bySubmission.quantity},on:{"input":function($event){_vm.bySubmission.quantity = $event !== '' ? Number($event) : 1}}})],1)]:_vm._e(),_vm._v(" "),_c('form-alert',{attrs:{"message":_vm.alert.message.value,"type":_vm.alert.type.value}}),_vm._v(" "),(_vm.draft && _vm.draft.settings && _vm.draft.settings.event_members_allowed && _vm.selectedMember && _vm.selectedMember.is_event_member)?_c('p',{staticClass:"mb-2"},[_vm._v("\n              If your nomination is accepted, you will be charged $100 of event membership fee per draft.\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap align-items-center mt-3 nom-add__actions"},[_c('app-button',{staticClass:"mr-3",attrs:{"type":"button","block":false,"loading":_vm.submitting,"disabled":!_vm.canSubmit || _vm.submitting},on:{"click":_vm.handleSubmit}},[_vm._v("\n                Add Nominations\n              ")]),_vm._v(" "),(_vm.activeTab !== 'submission')?_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/add-horse"}},[_vm._v("\n                Add Horses\n              ")]):_vm._e()],1)],2),_vm._v(" "),_c('appearances-drafts-desktop-banner',{attrs:{"appearances":_vm.appearances}})],1),_vm._v(" "),(_vm.$isUser || _vm.$isVolunteer || _vm.$isAdmin || (_vm.$isSecretaryMember && (!_vm.selectedMember || _vm.selectedMember.is_family)))?_c('nominations-add-list',{attrs:{"user-nominations":_vm.userNominations,"loading-nominations":_vm.loadingNominations,"target-user-id":_vm.$isAdmin && _vm.selectedMember ? _vm.selectedMember.id : null},on:{"reload":_vm.onListReload}}):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.loadFailed)?_c('div',{staticClass:"nom-add__layout"},[_c('div',{staticClass:"nom-add__forms"}),_vm._v(" "),_c('appearances-drafts-desktop-banner',{attrs:{"appearances":_vm.appearances}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('transition',{attrs:{"name":"banner-fade"}},[(_vm.appearances.sponsor_logo_mobile && !_vm.bannerHidden)?_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":_vm.appearances.sponsor_logo_mobile}})]):_vm._e()])],1)],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.eaa97d59fa473fff6082.js